import Button from "components/common/Button";
import React from "react";
import { ForecastNewProductPlanErrorType } from "./enums/ForecastNewProductPlanErrorType";

type ForecastNewProductPlanErrorProps = {
    errorType: ForecastNewProductPlanErrorType;
    error: string;
    action: () => void;
    onClose: () => void;
};

export default function ForecastNewProductPlanError(props: ForecastNewProductPlanErrorProps) {
    const { errorType, error, action, onClose } = props;

    const errorTitle =
        errorType === ForecastNewProductPlanErrorType.system
            ? "Something went wrong while generating insights"
            : "Something went wrong while generating insights";
    const errorMessage =
        errorType === ForecastNewProductPlanErrorType.system
            ? "We encountered a system error while processing your sales target data. Please try again later or contact support if the issue continues."
            : error;
    return (
        <div className="p-[60px] flex flex-col gap-3 items-center">
            <div className="flex flex-col gap-1 items-center">
                <i className="ri-error-warning-fill text-[#E4281D] text-2xl text-center"></i>

                <p className="text-[18px]  font-rocGroteskMedium">{errorTitle}</p>

                <p className="text-center text-sm text-slate-500">{errorMessage}</p>
            </div>

            <div className="flex gap-2">
                <Button
                    onClick={onClose}
                    btnText="Cancel"
                    btnClassname="!bg-[#F4F5F7] !px-[24px] mx-auto mt-6 cursor-pointer !text-[13px] s!py-2.5 rounded-[5px] !h-[42px] !whitespace-nowrap"
                />
                <Button
                    onClick={action}
                    btnText={
                        errorType === ForecastNewProductPlanErrorType.system
                            ? "Retry"
                            : "Edit details"
                    }
                    btnClassname="mx-auto mt-6 !px-[24px] cursor-pointer !text-[13px] !py-2.5 rounded-[5px] !h-[42px] !whitespace-nowrap"
                />
            </div>
        </div>
    );
}
